import * as React from 'react';
import { reduxForm, Field, InjectedFormProps } from 'redux-form';

import TextField from '../form/MaterialTextInput';

export interface FormData {
    name: string;
    email: string;
}

class MiniForm extends React.Component<InjectedFormProps<FormData, {}>, {}> {
    render() {
        const { handleSubmit } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div className='mini-form__description'>Create a Venue Account</div>
                <Field name='name' label='Your name' component={TextField} />
                <Field name='email' label='Your email' component={TextField} />
                <button type='submit' className='mini-form__button Button'>
                    SIGN UP
                </button>
            </form>
        );
    }
}

export default reduxForm({
    form: 'MiniForm',
})(MiniForm);
